import { render, staticRenderFns } from "./PrimaryTitle.vue?vue&type=template&id=95df0fa0&scoped=true"
import script from "./PrimaryTitle.vue?vue&type=script&lang=js"
export * from "./PrimaryTitle.vue?vue&type=script&lang=js"
import style0 from "./PrimaryTitle.vue?vue&type=style&index=0&id=95df0fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95df0fa0",
  null
  
)

export default component.exports